import Crud from '../views/Documento/Crud'
import Entity from '../views/Documento/Add'
import View from '../views/Documento/View'

let routes = {
    path: '/documentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/documentos/view/:id',
            name: 'ViewDocumento',
            component: View,
            meta: {
                pageTitle: 'Visualizar Documento',
                breadcrumb: [
                    { text: 'Assuntos', active: false, to: '/assuntos' },
                    { text: 'Documentos', active: false },
                    { text: 'Visualizar', active: true },
                ],
            },
        },
        {
            path: '/documentos/add',
            name: 'NewDocumento',
            component: Entity,
            meta: {
                pageTitle: 'Documentos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: false,
                        to: '/assuntos',
                    },
                    {
                        text: 'Documentos',
                        active: false,
                        to: '/documentos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/documentos/edit/:id?',
            name: 'EditDocumento',
            component: Entity,
            meta: {
                pageTitle: 'Documentos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: false,
                        to: '/assuntos',
                    },
                    {
                        text: 'Documentos',
                        active: false,
                        to: '/documentos',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/documentos',
            name: 'list-documentos',
            component: Crud,
            meta: {
                pageTitle: 'Documentos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: false,
                        to: '/assuntos',
                    },
                    {
                        text: 'Documentos',
                        active: true,
                    },
                ],
            },
        },
    ]
}

export default routes
